import { CircleDot, type LucideIcon, ShieldAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { BAND_TONE } from '../recipes'
import type { MatchBand } from '../types'
import { Pill } from './Pill'

/** One icon set for face and tattoo bands; `weak` carries its word only. */
const BAND_ICON: Record<MatchBand, LucideIcon | null> = {
  strong: ShieldAlert,
  possible: CircleDot,
  weak: null,
}

export interface BandPillProps {
  band: MatchBand
  /** Add "· provisional" (strengths not yet evaluated, SC-027). */
  provisional?: boolean
  size?: 'default' | 'compact'
  className?: string
}

/**
 * Strength of a face or tattoo candidate: "Možná zhoda". Warning tone for possible,
 * destructive for strong, muted for weak; never green, a match is a lead.
 */
export function BandPill({ band, provisional, size, className }: BandPillProps) {
  const { t } = useTranslation()
  const Icon = BAND_ICON[band]
  return (
    <Pill tone={BAND_TONE[band]} size={size} className={className}>
      {Icon && <Icon aria-hidden />}
      {t(`humint.common.bands.${band}`)}
      {provisional && <span className="font-normal">· {t('humint.common.bands.provisional')}</span>}
    </Pill>
  )
}
